export default __webpack_public_path__ + "static/media/crossIcon3.d7007ab9.svg";